import { render, staticRenderFns } from "./PersonelInformation.vue?vue&type=template&id=2e38968c"
import script from "./PersonelInformation.vue?vue&type=script&lang=js"
export * from "./PersonelInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports